import IconGoogle from 'ui/Icons/IconGoogle'
import IconFacebook from 'ui/Icons/IconFacebook'
import IconYahoo from 'ui/Icons/IconYahoo'
import IconApple from 'ui/Icons/IconApple'

export const RSA = process.env.REACT_APP_RSA

export const PROVIDERS = [
  {
    provider: 'googleplus',
    label: 'Google',
    icon: IconGoogle,
    akamai: process.env.REACT_APP_GOOGLE_AKAMAI,
  },
  {
    provider: 'facebook',
    label: 'Facebook',
    icon: IconFacebook,
    akamai: process.env.REACT_APP_FACEBOOK_AKAMAI,
  },
  {
    provider: 'yahoo-oauth2',
    label: 'Yahoo',
    icon: IconYahoo,
    akamai: process.env.REACT_APP_YAHOO_AKAMAI,
  },
  {
    provider: 'apple',
    label: 'Apple',
    icon: IconApple,
    akamai: process.env.REACT_APP_APPLE_AKAMAI,
  },
]
